import { render, staticRenderFns } from "./v-custom-form-model.vue?vue&type=template&id=74374f96&"
import script from "./v-custom-form-model.vue?vue&type=script&lang=js&"
export * from "./v-custom-form-model.vue?vue&type=script&lang=js&"
import style0 from "./v-custom-form-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports